export const isFullStatic = false
export const staticPath = "static-json"
export const publicPath = "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/tiktok_a_getstarted/dist/client//csr/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"